import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { Sgke331aResponseSearchresultList, Sgke331aResponseSupplystopResumeSts } from 'sg-api';
import { Sgke390dDialogComponent } from '../../../sgke390d/components/sgke390d-dialog/sgke390d-dialog.component';
import { Sgke390dDialogData } from '../../../sgke390d/models/sgke390d-dialog-data';


@Component({
  selector: 'app-sgke330d-result',
  templateUrl: './sgke330d-result.component.html',
  styleUrl: './sgke330d-result.component.scss',
})
export class Sgke330dResultComponent implements OnInit, OnDestroy, AfterViewInit {

  /** 検索結果リスト */
  @Input() searchresultList: Array<Sgke331aResponseSearchresultList>;
  /** 検索結果表示データソース */
  dataSource: MatTableDataSource<Sgke331aResponseSearchresultList>;
  /** ソート */
  @ViewChild('sort1', { static: true }) sort: MatSort;
  /** ダイアログ */
  ref: MatDialogRef<Sgke390dDialogComponent>;
  /** モーダル表示状況エミッター */
  @Output() onModalIsDisplayEvent = new EventEmitter();

  /** テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'scheduledDate',
    'energyClscode.aname',
    'rcvmnyConect.rcvmnyConectFlg',
    'autolockUmuFlg',
    'custmReferral',
    'supplystopresumptionWorkClscode.aname',
    'supplystopResumeSts.aname',
    'visitormei',
    'supplydestinationAddr',
    'sougouDivcd.aname',
    'meterDiscrm.aname',
    'payCtrNo',
    'sumaddMatomecode.aname',
  ];

  /**
   * コンストラクタ
   * @param {MatDialog} dialog
   * @param {Router} router
   * @param {ChangeDetectorRef} cd
   * @memberof Sgke330dResultComponent
   */
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private cd: ChangeDetectorRef,
  ) {}

  /**
   * オートロックボタンの背景色
   *
   * @param {string} flg オートロック有無フラグ
   * @return {*}  {string} 背景色
   * @memberof Sgke330dResultComponent
   */
  getAutolockBgColor(flg: string): string {
    return flg == '1' ? 'none' : 'darkgray';
  }

  /**
   *  作業種別ボタンのラベル
   *
   * @param {Sgke331aResponseSupplystopResumeSts} sagyoushubetu
   * @return {*} {string} ボタンラベル文字列
   * @memberof Sgke330dResultComponent
   */
  getSagyoSyubetsuLabel(
    sagyoushubetu: Sgke331aResponseSupplystopResumeSts,
  ): string {
    // 表示ラベル定義
    const sagyouShubetsuMap = new Map<string, string>([
      ['1', '供給\n停止'],
      ['2', '供給再開\n（一般）'],
      ['3', '供給再開\n（簡易）'],
    ]);
      return sagyouShubetsuMap.get(sagyoushubetu.codeValue);
  }

  /**
   * 初期処理
   * @memberof Sgke330dResultComponent
   */
  ngOnInit(): void {
    // Table表示データ作成
    this.dataSource = new MatTableDataSource<Sgke331aResponseSearchresultList>(
      this.searchresultList,
    );

    this.dataSource.sortingDataAccessor = (item, property) => {
      if (property === 'scheduledDate') {
        return item?.workScddt + item?.scheduledworkTimezoneCode.aname;
      } else {

        return property
          .split('.')
          .reduce((acc, key) => acc?.[key], item);
      }
    };

    this.cd.detectChanges();
  }

  /**
   * 画面描画後初回処理
   * @memberof Sgke330dResultComponent
   */
  ngAfterViewInit() {
    this.dataSource.sort ??= this.sort;
  }

  /**
   * 終了処理
   * @memberof Sgke330dResultComponent
   */
  ngOnDestroy(): void {
  }

  /**
   * オートロック有ボタン押下時処理
   * @param {Sgke331aResponseSearchresultList} row
   * @memberof Sgke330dResultComponent
   */
  onClickAutoLockButton(row: Sgke331aResponseSearchresultList) {
    let data: Sgke390dDialogData = {
      suppntSpno: row.suppntSpno,
      supplystopresumptionRrkno: row.supplystopresumptionRrkno,
      visitormei: row.visitormei + '（' + row.visitnamekana + '）',
    };

    this.onModalIsDisplayEvent.emit(false);
    this.ref = this.dialog.open(Sgke390dDialogComponent, {
      maxHeight: '95vh',
      width: '1000px',
      disableClose: true, // 背景クリックのクローズ禁止
      data: data,
    });

    this.ref.afterClosed().subscribe((result) => {
      this.onModalIsDisplayEvent.emit(true);
    });
  }

  /**
   * 作業種別ボタン押下時処理
   * @param {Sgke331aResponseSearchresultList} row
   * @memberof Sgke330dResultComponent
   */
  onClickOperation(row: Sgke331aResponseSearchresultList) {
    // 供給停止・再開作業種別コード（クリックしたレコードから取得）
    let operationCode = row.supplystopresumptionWorkClscode.codeValue;

    // 画面間パラメータ
    const param = {
      // 供給地点特定番号
      suppntSpno: row.suppntSpno,
      // 供給停止再開履歴番号
      supplystopresumptionRrkno: row.supplystopresumptionRrkno,
    };

    // 供給停止ボタン('1')押下時
    if (operationCode == '1') {
      this.router.navigate(['/sgke/sgke340d/', param]);
      // 一般供給再開ボタン('2')もしくは簡易供給再開ボタン('3')押下時
    } else if (operationCode == '2' || operationCode == '3') {
      this.router.navigate(['/sgke/sgke360d/', param]);
    }
  }

  /**
   * マップアイコン押下時処理
   * @param {Sgke331aResponseSearchresultList} row
   * @memberof Sgke330dResultComponent
   */
  onClickMapIcon(row: Sgke331aResponseSearchresultList) {
    const url: string = 'https://www.google.com/maps/search/';

    // 住所のスペース除去
    let trimedAddress = row?.forsearchSupplydestinationaddress.replace(/\s+/g, '');

    // URL末尾につけるパラメータを作成
    const paramsObj = new URLSearchParams({
      api: '1',
      query: trimedAddress,
    });

    // paramsObjをクエリ文字列に変換
    let params: string = paramsObj.toString();
    params = '?' + params;

    // GoogleMapのURLのパラメータに供給先住所を設定し新規タブで開く
    window.open(`${url}${params}`, '_blank', 'noopener');
  }

  /**
   * お客さま照会ボタン押下時処理
   * （請求ポータル画面への遷移）
   * @param {Sgke331aResponseSearchresultList} row
   * @memberof Sgke330dResultComponent
   */
  onClickShokai(row: Sgke331aResponseSearchresultList): void {
    // 受付基盤UIのURL取得
    const url: string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;

    // anyタイプのパラメータ
    let paramToOutside: any = {};

    // お客さま番号
    let customerNo: string = row.visitornumber;
    // 支払契約番号
    let paymentContractNo: string = row.payCtrNo;

    // パラメータ設定
    // お客さま番号
    if (customerNo) {
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if (paymentContractNo) {
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }
    // 起動元画面
    paramToOutside.c__launchSourceScreen = '11';

    //  anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    }

    // 別タブで該当URLを開く
    window.open(`${url}${params}`, '_blank');
  }
}
